import React from "react";
import axios from "axios";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import Button from "@mui/material/Button";
import { useAuth } from "../../login/loginPage/AuthContext";
import { Navigate } from "react-router-dom";
import { Button } from 'primereact/button';


export const Logout = ({ onClose }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { logout } = useAuth();

  const [redirect, setRedirect] = useState(false);

  const handleConfirm = () => {
    logout();

    // Crée un BroadcastChannel nommé "auth"
    const eventChannel = new BroadcastChannel("auth");

    // Envoie un message "logout" à travers le canal
    eventChannel.postMessage("logout");

    // Ferme le canal après l'envoi du message
    eventChannel.close();

    setRedirect(true);
  };

  const handleCancel = () => {
    if (typeof onClose === "function") {
      onClose();
    }
  };

  if (redirect) {
    return <Navigate to="/login" />;
  }

  return (
    <div>
      <div>
        <div className="modalContainer" style={{ textAlign: "center" }}>
          <p>Voulez-vous vraiment vous déconnecter ? </p>
          <Button
            label="Oui"
            icon="pi pi-power-off"
            severity="info"
            style={{ margin: "10px" }}
            onClick={handleConfirm}
          />
          <Button
            label="Non"
            icon="pi pi-replay"
            severity="secondary"
            style={{ margin: "10px" }}
            onClick={handleCancel}
          />
          <ToastContainer />
        </div>
      </div>
    </div>
  );
};
